import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import * as FeedbackActions from '@collections/feedback/feedback.actions';
import { getJob } from '@collections/jobs';
import { getCandidateById } from '@modules/candidates/store';
import { CandidateAdapter, Feedback, FeedbackType, Job, ThumbValue } from '@shared/models';

@Component({
  selector: 'mojo-feedback-panel',
  templateUrl: './feedback-panel.component.html',
  styleUrls: ['./feedback-panel.component.scss'],
})
export class FeedbackPanelComponent implements OnInit, OnDestroy {
  @Input() jobId;
  @Input() candidateId;
  @Input() isCandidateCardHovered = false;
  @Input() showOnHover = true;
  @Input() feedback: Feedback;
  @Input() totalThumbsUp: number;
  @Input() isMobileView = false;
  @Output() feedbackPanelOpened: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() thumbChange = new EventEmitter<Feedback>();

  @ViewChild('iconContainer') iconContainer: ElementRef;

  THUMB_UP = ThumbValue.UP;
  THUMB_DOWN = ThumbValue.DOWN;
  isMenuOpened = false;
  displayThumbs = false;
  subscriptions = new Subscription();

  candidate$: Observable<CandidateAdapter>;
  job$: Observable<Job>;

  constructor(private store: Store<{}>) {}

  ngOnInit() {
    this.candidate$ = this.store
      .select(getCandidateById, { id: this.candidateId })
      .pipe(map((candidate) => new CandidateAdapter(candidate)));
    this.job$ = this.store.select(getJob(this.jobId));
  }

  onThumbSent(feedback: Feedback): void {
    this.store.dispatch(FeedbackActions.feedbackCreate({ feedback }));
  }

  onThumbWithReasons(feedbackArray: Feedback[]): void {
    this.store.dispatch(FeedbackActions.feedbackCreateMany({ feedbackArray }));
  }

  shouldRunConfetti(): boolean {
    return this.totalThumbsUp < 3 || this.totalThumbsUp % 3 === 2;
  }

  createFeedbackModel(): Feedback {
    return {
      jobId: this.jobId,
      candidateId: this.candidateId,
      type: FeedbackType.THUMB,
    };
  }

  hideThumbs() {
    if (!this.isMobileView) {
      this.displayThumbs = false;
    }
  }

  showThumbs() {
    if (!this.isMobileView) {
      this.displayThumbs = true;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
